import { ca } from '@cian/analytics';

import { ELeaveContactsSendFrom, TLeaveContactsSendFromAllowedValues } from '../../types/promoInfo/leaveContacts';

export function trackLeaveContactsFormSubmit(sentFrom: TLeaveContactsSendFromAllowedValues) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSalePromo',
    action: 'Click',
    label: `send/${
      {
        [ELeaveContactsSendFrom.B2bMasterClass]: 'webinar',
      }[sentFrom]
    }`,
  });
}
